// extracted by mini-css-extract-plugin
export default {"container":"container--fWZ0j","text":"text--B2v_M","button":"button--tanzQ"};